import { render, staticRenderFns } from "./Masking.vue?vue&type=template&id=afa63d60&"
import script from "./Masking.vue?vue&type=script&lang=js&"
export * from "./Masking.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports